module.exports = __webpack_public_path__ + "img/male-newborn-foot.9b2971ff.svg";